angular.module('account').config([
        'AppRoutesProvider',
        '$stateProvider',
        function config(
            AppRoutesProvider,
            $stateProvider
        ) {
            'use strict';

            var appRoutes = {
                'changepassword': {
                    state: 'change-password',
                    route: '/changepassword',
                },
            };

            AppRoutesProvider.setupAppRoutes(appRoutes);

            $stateProvider
                .state(appRoutes.changepassword.state, {
                    url: appRoutes.changepassword.route,
                    component: 'changePassword'
                });
        }]);
